import { ButtonHTMLAttributes, forwardRef, ReactNode } from "react";
import { clsx } from "clsx";
import classes from "./ToolbarButton.module.less";

export interface ToolbarButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    icon?: ReactNode;
    /** Reads as in force (e.g. filters applied), outlined in the primary colour. */
    active?: boolean;
    /** A number after the label, as a pill; nothing when zero. */
    count?: number;
}

/**
 * A button for the row of controls above a table or a page section: the same
 * tinted style as the segmenter and the search box next to it. Icon-only
 * without children (give it an aria-label then).
 */
export const ToolbarButton = forwardRef<HTMLButtonElement, ToolbarButtonProps>(
    ({ icon, active, count, className, children, ...restProps }, ref) => (
        <button
            ref={ref}
            type="button"
            className={clsx(
                classes.button,
                children == null && classes["button--icon"],
                active && classes["button--active"],
                className
            )}
            {...restProps}
        >
            {icon}
            {children}
            {!!count && <span className={classes.count}>{count}</span>}
        </button>
    )
);

ToolbarButton.displayName = "ToolbarButton";
